import axiosInstance from "../api/axiosInstance";

/**
 * Fetches the full hierarchical tree of locations and assets.
 * 
 * @returns {Promise<Object>} - A promise that resolves to an object containing success status and tree data.
 */
export const fetchFullTree = async (mode = "physical") => {
    try {
        const response = await axiosInstance.get(`/api/tree?mode=${mode}`);
        return { success: true, data: response.data };
    } catch (error) {
        console.error("Error fetching full tree:", error);
        return { success: false, error: error.message };
    }
};
